import { defineStore } from 'pinia'
import axios from 'axios'

export const useVersionStore = defineStore('version', {
  state: () => ({
    appVersion: '',
  }),
  getters: {
    getAppVersion() {
      return this.appVersion
    },
  },
  actions: {
    async loadAppVersion() {
      const resp = await axios.get('/')
      const match = resp.data.match(/\/js\/app.([a-z0-9]*).js/)
      return match?.[1] ?? ''
    },
    async checkAppVersion(throwOnMismatch = false) {
      if (this.appVersion == '') return

      const remoteVersion = await this.loadAppVersion()
      if (this.appVersion !== remoteVersion) {
        const errorMessage = 'Application is obsolete, please reload'
        console.error(errorMessage)

        //if (throwOnMismatch) {
        //    throw errorMessage;
        //}
      }

      return this.appVersion === remoteVersion
    },
    async initAppVersion() {
      console.log('initAppVersion - current', this.appVersion)
      this.appVersion = await this.loadAppVersion()
      console.log('initAppVersion - latest', this.appVersion)
    },
  },
  persist: true,
})
